import PropTypes from 'prop-types';
import React from 'react';
import { FacebookLink } from './FacebookLink.js';
import { FacebookMessengerLink } from './FacebookMessengerLink.js';
import { TwitterLink } from './TwitterLink.js';
import { LightBoxWrapper } from './LightBoxWrapper.js';
import { redirectToTwitterWithShortenedUrl } from '../sharebar/sharebarHelperFunctions.js';


export class ShareLightBox extends React.PureComponent {
    render() {
        const props = this.props;
        return (
            <LightBoxWrapper fixed={true} unMountHandler={props.hideShareLightBox}>
                <div>
                    <div className="share-lightbox">
                        <h2>Share this page</h2>
                        <div className="share-lightbox-content">
                            <h3>{props.pageTitle}</h3>
                            <ul className="share-wrapper">
                                <li>
                                    <FacebookLink
                                        urlToShare={props.urlToShare}
                                        getTrackingLink={getTrackingLink /* getTrackingLink is globally-defined */}
                                        facebookAppId={facebookAppId /* facebookAppId is globally-defined */}
                                        onFacebookClick={() => {}}
                                        pageName={props.pageName}
                                    />
                                </li>
                                <li>
                                    <FacebookMessengerLink
                                        className="icon icon-messenger heap-messenger-share"
                                        urlToShare={props.urlToShare}
                                        getTrackingLink={getTrackingLink /* getTrackingLink is globally-defined */}
                                        facebookAppId={facebookAppId /* facebookAppId is globally-defined */}
                                        pageName={props.pageName}
                                    />
                                </li>
                                <li>
                                    <TwitterLink
                                        urlToShare={props.urlToShare}
                                        getTrackingLink={getTrackingLink /* getTrackingLink is globally-defined */}
                                        text={props.twitterText}
                                        onTwitterClick={redirectToTwitterWithShortenedUrl}
                                        pageName={props.pageName}
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </LightBoxWrapper>
        );
    }
}

ShareLightBox.propTypes = {
    hideShareLightBox: PropTypes.func.isRequired,
    pageTitle: PropTypes.string.isRequired,
    urlToShare: PropTypes.string.isRequired,
    pageName: PropTypes.string.isRequired,
    twitterText: PropTypes.string.isRequired,
};
